import { inject, Service } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { ApiClient } from '../../api/api-client';
import { Api } from '../../api/generated/api';
import { LanguageService } from '../../core/providers/language/language.service';
import { LayoutService } from '../../core/providers/layout/layout.service';
import { FlexiblePortalClickContextService } from './flexible-portal-click-context.service';
import { IFlexiblePortalSettings } from './flexible-portal.interface';

@Service()
export class FlexiblePortalService {
  private api = inject(ApiClient);
  private languageService = inject(LanguageService);
  private layoutService = inject(LayoutService);
  private titleService = inject(Title);
  private clickContext = inject(FlexiblePortalClickContextService);

  private portalSettings!: IFlexiblePortalSettings;

  fetchSettings$(fixedUrlCode: string): Observable<IFlexiblePortalSettings> {
    return this.api.get(Api.fbi.takeaway.portal, { pathParams: { fixedUrlCode } });
  }

  setPortalSettings(settings: IFlexiblePortalSettings): void {
    this.portalSettings = settings;
    this.clickContext.portalUuid = settings.portalUuid;
  }

  getPortalSettings(): IFlexiblePortalSettings {
    return this.portalSettings;
  }

  setBasicSettings(): void {
    this.setLayoutCustomSettings();
    this.languageService.initContextLanguage(this.getPortalSettings().languages);
    this.setTabName();
  }

  private setLayoutCustomSettings(): void {
    const { branding } = this.getPortalSettings();

    if (branding?.logoFileUuid) {
      this.layoutService.setVenueLogo(branding.logoFileUuid);
    }
    if (branding?.colorTint) {
      this.layoutService.setLayoutDefaultColor(branding.colorTint);
    }
    this.layoutService.loadedLayoutData$.next(true);
  }

  private setTabName(): void {
    const brandName: string = this.getPortalSettings().venueName;
    const tabTitle: string = brandName ? `${brandName} - Foodback` : 'Foodback';

    this.titleService.setTitle(tabTitle);
    this.layoutService.setVenueName(brandName);
  }
}
